const docReady = fn => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

const applyCardHoverEffect = parentEl => {
  const cardPeople = parentEl.querySelectorAll('.card-people');

  cardPeople.forEach(card => {
    card.addEventListener('mouseover', () => {
      const bg = card.getAttribute('data-bg');
      const photo = card.querySelector('.card-people-photo');
      if (photo) {
        photo.style.boxShadow = `0 0 0 10px ${bg}`;
      }
    });

    card.addEventListener('mouseleave', () => {
      const bg = card.getAttribute('data-bg');
      const photo = card.querySelector('.card-people-photo');
      if (photo) {
        photo.style.boxShadow = `0 0 0 6px ${bg}`;
      }
    });
  });
};

docReady(() => {
  applyCardHoverEffect(document);
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      applyCardHoverEffect(mutation.target);
    });
  });
  observer.observe(document, { childList: true, subtree: true });
});
